import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { localStorage } from "@/utils/storage";

import enLocale from 'element-ui/lib/locale/lang/en' //导入element ui中的默认英文配置
import zhLocale from 'element-ui/lib/locale/lang/zh-CN' //导入element ui中的默认中文配置
import zh from './zh-cn' //导入我们在zh.js文件中的词条
import en from './en' //导入我们在en.js文件中的词条
Vue.use(VueI18n)

const messages = {
        en: {
            ...enLocale,
            ...en //把导入的英文词条合并
        },
        zh: {
            ...zhLocale,
            ...zh //把导入的中文词条合并
        }
    }
    /**
     * 获取当前系统使用语言字符串
     *
     * @returns zh|en ...
     */
export const getLanguage = () => {
    // 本地缓存获取
    let language = localStorage.get("language");
    if (language) {
        return language;
    }
    // 浏览器使用语言
    language = navigator.language.toLowerCase();
    const locales = Object.keys(messages);
    for (const locale of locales) {
        if (language.indexOf(locale) > -1) {
            return locale;
        }
    }
    return "zh";
};

const i18n = new VueI18n({
    locale: getLanguage(),
    legacy: false,
    silentTranslationWarn: true,
    messages: messages,
    globalInjection: true, // 全局模式，可以直接使用 $t
});

export default i18n //最后导出i18n